"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class VehicleDetail extends React.PureComponent {
        static defaultProps = {
            vehicle: false
        };

        state = {
            section: "modal-listing-history"
        };

        handleHideDetail = () => {
            flex.trigger("workbench:set-current-vehicle", false);
        };

        handleChangeSection = (section) => {
            this.setState({ section: section });
        };

        render() {
            const self = this;
            const vehicle = this.props.vehicle || {};
            const build = vehicle.build || {};
            const instance = vehicle.instance || {};
            const section = this.state.section;
            return (
                <div className="modal fade in" id="info-modal" aria-hidden="false" style={{ display: "block", paddingRight: "17px" }}>
                    <div className="modal-backdrop fade in" style={{ height: "756px" }}></div>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content has-navigation">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={self.handleHideDetail}><span aria-hidden="true">x</span></button>

                            <h3 style={{ paddingLeft: "20px" }} className="modal-subtitle">{build.title} ({build.vin})</h3>
                            <div className={`modal-active-content modal-toggle ${section === "modal-listing-history" ? "active" : false}`} id="modal-listing-history">
                                <div className="modal-header listing-history-header">
                                    <h2 className="modal-title">Listing History</h2>
                                </div>

                                <div className="modal-body">
                                    <div className="tablesaw-bar mode-swipe"><div className="tablesaw-advance"><a href="#" className="tablesaw-nav-btn btn btn-micro left disabled" title="Previous Column"></a><a href="#" className="tablesaw-nav-btn btn btn-micro right disabled" title="Next Column"></a></div><div className="tablesaw-advance minimap"><ul className="tablesaw-advance-dots"><li><i></i></li><li><i></i></li><li><i></i></li><li><i></i></li><li><i></i></li><li><i></i></li><li><i></i></li></ul></div></div><table id="clean-table" className="table table-clean tablesaw-swipe" data-tablesaw-mode="swipe" data-tablesaw-minimap="" >
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th className="">Channel</th>
                                                <th className="">Location/Website</th>
                                                <th className=""># Views</th>
                                                <th className=""># Bids</th>
                                                <th className="">High Bid</th>
                                                <th className="">High Bidder</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr className="highlight">
                                                <td>Wed Sept 26 2014</td>
                                                <td className="">Physical Auction</td>
                                                <td className="">Manheim San Francisco Bay</td>
                                                <td className="">NA</td>
                                                <td className="">NA</td>
                                                <td className="">NA</td>
                                                <td className="">NA</td>
                                            </tr>
                                            <tr>
                                                <td>Web Sept 21 2014</td>
                                                <td className="">Physical Auction</td>
                                                <td className="">Manheim San Francisco Bay</td>
                                                <td className="">7</td>
                                                <td className="">7</td>
                                                <td className="">$72,010</td>
                                                <td className="">Mercedes-Benz of Monterey</td>
                                            </tr>
                                            <tr>
                                                <td>Fri Sept 16 2014</td>
                                                <td className="">Online</td>
                                                <td className="">OVE.com</td>
                                                <td className="">12</td>
                                                <td className="">12</td>
                                                <td className="">$71,680</td>
                                                <td className="">Mercedes-Benz of Fairfield</td>
                                            </tr>
                                            <tr>
                                                <td>Wed Sept 14 2014</td>
                                                <td className="">Online</td>
                                                <td className="">OVE.com</td>
                                                <td className="">10</td>
                                                <td className="">10</td>
                                                <td className="">$72,000</td>
                                                <td className="">Mercedes-Benz of Modesto</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-mmr" ? "active" : false}`} id="modal-mmr">
                                <div className="modal-header">
                                    <h2 className="modal-title">MMR</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-flex-value" ? "active" : false}`} id="modal-flex-value">
                                <div className="modal-header">
                                    <h2 className="modal-title">RMS Value - Pricing Value</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-vauto" ? "active" : false}`} id="modal-vauto">
                                <div className="modal-header">
                                    <h2 className="modal-title">vAuto</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-kbb" ? "active" : false}`} id="modal-kbb">
                                <div className="modal-header">
                                    <h2 className="modal-title">KBB</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-sell-date" ? "active" : false}`} id="modal-sell-date">
                                <div className="modal-header">
                                    <h2 className="modal-title">Sell Date</h2>
                                </div>

                                <div className="modal-body">
                                    <dl className="dl-horizontal">
                                        <dt>Listed On:</dt>
                                        <dd>February 23, 2014</dd>

                                        <dt>Days Listed:</dt>
                                        <dd>21</dd>
                                    </dl>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-location" ? "active" : false}`} id="modal-location">
                                <div className="modal-header">
                                    <h2 className="modal-title">Location</h2>
                                </div>

                                <div className="modal-body">
                                    <dl className="dl-horizontal">
                                        <dt>Location:</dt>
                                        <dd>San Francisco, CA</dd>

                                        <dt>Dealer:</dt>
                                        <dd>Manheim San Francisco Mercedes-Benz</dd>
                                    </dl>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-autocheck" ? "active" : false}`} id="modal-autocheck">
                                <div className="modal-header">
                                    <h2 className="modal-title">AutoCheck</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-carfax" ? "active" : false}`} id="modal-carfax">
                                <div className="modal-header">
                                    <h2 className="modal-title">CarFax</h2>
                                </div>

                                <div className="modal-body">
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-price" ? "active" : false}`} id="modal-price">
                                <div className="modal-header">
                                    <h2 className="modal-title">Price</h2>
                                </div>

                                <div className="modal-body">
                                    <dl className="dl-horizontal">
                                        <dt>Price:</dt>
                                        <dd>$57,875</dd>

                                        <dt>MMR:</dt>
                                        <dd>$43,228</dd>

                                        <dt>Buy It Now Price:</dt>
                                        <dd>$75,000</dd>
                                    </dl>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-documents" ? "active" : false}`} id="modal-documents">
                                <div className="modal-header">
                                    <h2 className="modal-title">Documents</h2>
                                </div>

                                <div className="modal-body">
                                    <ul className="modal-list">
                                        <li><a href="#">Document 1</a></li>
                                        <li><a href="#">Document 2</a></li>
                                        <li><a href="#">Document 3</a></li>
                                        <li><a href="#">Document 4</a></li>
                                        <li><a href="#">Document 5</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-damages" ? "active" : false}`} id="modal-damages">
                                <div className="modal-header">
                                    <h2 className="modal-title">Damages</h2>
                                </div>

                                <div className="modal-body">
                                    <h3>Cosmetic Conventional Paint and Body Not Required (1 item)</h3>

                                    <dl className="dl-horizontal">
                                        <dt>Description:</dt>
                                        <dd>L Rocker Panel Outer</dd>

                                        <dt>Condition:</dt>
                                        <dd>Dent/No Paint Dmg</dd>

                                        <dt>Severity:</dt>
                                        <dd>1" to 2"</dd>
                                    </dl>

                                    <h3>Paint and body requires conventional repair (2 items)</h3>

                                    <dl className="dl-horizontal">
                                        <dt>Description:</dt>
                                        <dd>Front Bumper Cover</dd>

                                        <dt>Condition:</dt>
                                        <dd>Curb Rash</dd>

                                        <dt>Severity:</dt>
                                        <dd>GR 12"</dd>
                                    </dl>

                                    <dl className="dl-horizontal">
                                        <dt>Description:</dt>
                                        <dd>Rear Bumper Cover</dd>

                                        <dt>Condition:</dt>
                                        <dd>Curb Rash</dd>

                                        <dt>Severity:</dt>
                                        <dd>GR 12"</dd>
                                    </dl>
                                </div>
                            </div>

                            <div className={`modal-active-content modal-toggle ${section === "modal-notes" ? "active" : false}`} id="modal-notes">
                                <div className="modal-header">
                                    <h2 className="modal-title">Notes</h2>
                                </div>

                                <div className="modal-body">
                                    <p>No damages, good price.  Viable option</p>
                                </div>
                            </div>

                            <div className="modal-navigation">
                                <ul>
                                    <li><a href="#modal-listing-history" className={section === "modal-listing-history" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-listing-history")} data-toggle="modal-content">Listing History</a></li>
                                    <li><a href="#modal-mmr" className={section === "modal-mmr" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-mmr")} data-toggle="modal-content">MMR</a></li>
                                    <li><a href="#modal-flex-value" className={section === "modal-flex-value" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-flex-value")} data-toggle="modal-content">RMS Value – Pricing Value</a></li>
                                    <li><a href="#modal-vauto" className={section === "modal-vauto" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-vauto")} data-toggle="modal-content">vAuto</a></li>
                                    <li><a href="#modal-kbb" className={section === "modal-kbb" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-kbb")} data-toggle="modal-content">KBB</a></li>
                                    <li><a href="#modal-sell-date" className={section === "modal-sell-date" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-sell-date")} data-toggle="modal-content">Sell Date</a></li>
                                    <li><a href="#modal-location" className={section === "modal-location" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-location")} data-toggle="modal-content">Location</a></li>
                                    <li><a href="#modal-autocheck" className={section === "modal-autocheck" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-autocheck")} data-toggle="modal-content">AutoCheck</a></li>
                                    <li><a href="#modal-carfax" className={section === "modal-carfax" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-carfax")} data-toggle="modal-content">CarFax</a></li>
                                    <li><a href="#modal-price" className={section === "modal-price" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-price")} data-toggle="modal-content">Price</a></li>
                                    <li><a href="#modal-documents" className={section === "modal-documents" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-documents")} data-toggle="modal-content">Documents</a></li>
                                    <li><a href="#modal-damages" className={section === "modal-damages" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-damages")} data-toggle="modal-content">Damages</a></li>
                                    <li><a href="#modal-notes" className={section === "modal-notes" ? "active" : false} onClick={self.handleChangeSection.bind(self, "modal-notes")} data-toggle="modal-content">Notes</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return VehicleDetail;
};

module.exports = initComponent;
